<div class="tab-box">
  <div class="title-ind">
  <h1 class="title-tab">Centros</h1>

</div>
    <div class="acciones-tabla">
      
      <app-input-tabla (keyup)="applyFilter($event)"></app-input-tabla>
      <div>
        <button class="boton-añadir" (click)="openDialog()" *ngIf="role != 'user'">+ Añadir</button>
        <button class="boton-descarga" (click)="exportAsExcel()">
          <img class="boton-descarga__icon" src="../../../../assets/descargar.svg" />
          Descargar
        </button>
      </div>
    </div>
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
      <ng-container matColumnDef="cliente.nombreComercial">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>CLIENTES
          <!-- <mat-form-field appearance="outline">
            <mat-select name="cliente" placeholder="CLIENTE" class="filtro-tabla" [(ngModel)]="selectedValue" multiple>
              <div class="boton-filtro" (click)="unselect()">Limpiar Filtros</div>
              <mat-option *ngFor="let cliente of centrosFilter" [value]="cliente" #matOption (click)="selectCentro(matOption)">
                {{cliente.clientes[0]?.nombreComercial}}
              </mat-option>
    
            </mat-select>
           
          </mat-form-field> -->

        </th>
        <td mat-cell *matCellDef="let centro" (click)="openDetails(centro.id)">
          <div *ngIf="centro.clientes; else elseBlock">
            <div *ngFor="let cliente of centro.clientes" (click)="setIdCliente(cliente.id)">
              {{ cliente.nombreComercial }}
            </div>
          </div>
        </td>
        <ng-template #elseBlock>-</ng-template>
      </ng-container>
      <ng-container matColumnDef="id">
        <th color="primary" mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
        <td mat-cell *matCellDef="let centro" (click)="openDetails(centro.id)">{{ centro.IdCentro }}</td>
      </ng-container>
      <ng-container matColumnDef="nombre">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>NOMBRE<!-- <mat-form-field appearance="outline">
          <mat-select name="nombre" placeholder="NOMBRE" class="filtro-tabla" [(ngModel)]="selectedValue" multiple>
            <div class="boton-filtro" (click)="unselect()">Limpiar Filtros</div>
            <mat-option *ngFor="let centro of centrosFilter" [value]="centro" #matOption (click)="selectCentro(matOption)">
              {{centro.nombre}}
            </mat-option>
  
          </mat-select>
         
        </mat-form-field> -->
      </th>
        <td mat-cell *matCellDef="let centro" (click)="openDetails(centro.id)">{{ centro.nombre }}</td>
      </ng-container>
      <ng-container matColumnDef="contactoResponsable.nombre">
        <th color="primary" mat-header-cell *matHeaderCellDef mat-sort-header>CONTACTO</th>
        <td mat-cell *matCellDef="let centro" (click)="openDetails(centro.id)">{{ centro.contactoResponsable?.nombre }}</td>
      </ng-container>
      <ng-container matColumnDef="direccion.nombre">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>DIRECCIÓN</th>
        <td mat-cell *matCellDef="let centro" (click)="openDetails(centro.id)">
          {{ centro.direccion?.tipoVia}} {{ centro.direccion?.nombre}} {{ centro.direccion?.numero}} {{ centro.direccion?.ccaa}}
        </td>
      </ng-container>   
      <ng-container matColumnDef="indicadores">
        <th mat-header-cell *matHeaderCellDef>INDICADORES</th>
        <td mat-cell *matCellDef="let centro">
     
          <div class="stackedBar" style="display: flex;">
            <p>Obligatorios</p><canvas  id="o{{centro.id}}"></canvas>
            
          </div>

          <div class="stackedBarAdic" style="display: flex;">
            <p>Adicionales</p><canvas  id="a{{centro.id}}"></canvas>
            
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="acciones" >
        <th mat-header-cell *matHeaderCellDef>ACCIONES</th>
        <td mat-cell *matCellDef="let centro">
          <img
            class="tabla-editar"
            src="../../../../../../assets/lapiz.png"
            (click)="openDialogAddCliente(centro.id)"
          />
          <img
            class="tabla-borrar"
            src="../../../../../../assets/trash.png"
            (click)="handleClick(centro.id)"
          />
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10,15,20]" (click)="getCentrosByContratista()"></mat-paginator>
  </div>
  
